module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="league-info hidden-mobile">\n	<picture>\n		<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" type="image/png">\n		<img src="/assets/images/test-avatar.png?v=1" alt="">\n	</picture>\n	<p>'+
((__t=( name ))==null?'':_.escape(__t))+
'</p>\n</div>\n\n<div class="right-side-content">\n	<div class="select-wrapper">\n		<select class="base-select js-change-fixture">\n			';
 _.each(fixture_item, function(item, index) { 
__p+='\n			<option value="'+
((__t=( index ))==null?'':_.escape(__t))+
'"\n					'+
((__t=( item.is_selected ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n				'+
((__t=( item.first_opponent.name ))==null?'':_.escape(__t))+
' vs '+
((__t=( item.second_opponent.name ))==null?'':_.escape(__t))+
'\n			</option>\n			';
 }) 
__p+='\n		</select>\n	</div>\n\n</div>';
}
return __p;
};
